// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$String from "../../../../node_modules/rescript/lib/es6/string.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_List from "../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Mem$Showside from "./Mem.bs.js";
import * as Tap$Showside from "./Tap.bs.js";
function concatWithoutRepeat(a, b) {
  var a$1 = a.trim();
  var b$1 = b.trim();
  var wordsInA = $$String.split_on_char(/* ' ' */32, a$1);
  var wordsInB = $$String.split_on_char(/* ' ' */32, b$1);
  var aAllCaps = a$1.toUpperCase() === a$1 && a$1 !== "";
  var bAllCaps = b$1.toUpperCase() === b$1 && b$1 !== "";
  var aEndsWith = Belt_Option.map(Belt_List.get(wordsInA, Belt_List.length(wordsInA) - 1 | 0), function (word) {
    return word.toLowerCase();
  });
  var bStartsWith = Belt_Option.map(Belt_List.get(wordsInB, 0), function (word) {
    return word.toLowerCase();
  });
  var newB = Caml_obj.equal(aEndsWith, bStartsWith) ? Belt_List.toArray(Belt_List.mapWithIndex(wordsInB, function (idx, str) {
    if (idx !== 0) {
      return str;
    } else {
      return "";
    }
  })).join(" ") : b$1;
  var reStartsWith = new RegExp("^" + a$1);
  var newB$1 = newB.replace(reStartsWith, "");
  var res = a$1 + " " + newB$1;
  if (aAllCaps || bAllCaps) {
    return res.toUpperCase();
  } else {
    return res;
  }
}
function safeConcat(leftHand, rightHand) {
  if (rightHand.startsWith(leftHand)) {
    return rightHand;
  } else {
    return leftHand + rightHand;
  }
}
var stripHTML = Mem$Showside.mem(function (text) {
  return Tap$Showside.tap(document.createElement("DIV"), function (__x) {
    __x.innerHTML = text;
  }).textContent;
});
function fromInt(max, minOpt, $$int) {
  var min = minOpt !== undefined ? minOpt : 1;
  if (min > $$int) {
    return;
  } else if (max !== undefined && $$int > max) {
    return "+" + String(max);
  } else {
    return String($$int);
  }
}
export { concatWithoutRepeat, safeConcat, stripHTML, fromInt };
/* stripHTML Not a pure module */